import React,{useState} from 'react';
const useFormField = ({initialValue = ""}) => {
    const [value,setValue] = useState(initialValue);
    const onChange = (event) => {
        if(event && event.target){
            setValue(event.target.value);
        }
    }
    return {
        value,
        onChange
    };
}
export default useFormField;